<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>

  export default {
    components: {
    },
    data: () => {
      return {}
    },
    mounted () {
    },
    computed: {

    },
    created () {

    },
    methods: {

    }
  }
</script>

<style lang="stylus">
    .marl {
        margin-left: 800px;
    }
</style>
